<template>
	<div>
		<v-container style="max-width:1024px">
			<v-card style="padding-left:16px; padding-right:16px; padding-top:8px; padding-bottom:8px">
				<h1>{{ this.lng.title }}</h1>
				<p>Haplabit UG (haftungsbeschränkt) built the HAQCS Remote app as a Free app. This SERVICE is provided by Haplabit UG (haftungsbeschränkt) at no cost and is intended for use as is.</p>
				<p>This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.</p>
				<p>If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.</p>
				<!-- <p>The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at Leaf Ventilation unless otherwise defined in this Privacy Policy.</p> -->
				<p><strong>Information Collection and Use</strong></p>
				<p>For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to Network SSID, Network password, Network IP addresses. The information that we request will be retained by us and used as described in this privacy policy.</p>
				<p><strong>Log Data</strong></p>
				<p>We want to inform you that whenever you use our Service, in a case of an error in the app we may collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.</p>
				<p><strong>Security</strong></p>
				<p>We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. Any and all data we collect, with the exception of Log Data, is stored locally in either your device’s local storage or in the flash memory of connected ventilation units. The data is not sent over the internet.</p>
				<p><strong>Changes to This Privacy Policy</strong></p>
				<p>We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
				<p>This policy is effective as of 2024-03-01</p>
				<p><strong>Contact Us</strong></p>
				<p>If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at info@hapla.eu.</p>

			</v-card>
		</v-container>

		<!-- white space (to keep footer away) -->
		<div v-if="!showSuccessAlert" class="spacing-128"/>
		<div v-if="showSuccessAlert" style="height:1200px"/>
	</div>
</template>

<script>
export default {
	name: 'Contact',
	created: function() {
		this.checkLng();
	},
	data () {
		return {
			// language
            checkLng: function() {
				if(this.$route.path.startsWith('/privacy-policy')) {
				    setTimeout(() => { this.checkLng() }, 500);
				    if(this.language !== this.updateLngLastLng) {
				        this.updateLng();
				    }
				}
            },
            updateLng: function() {
				this.lng = this.messages[this.language];
				this.updateLngLastLng = this.language;
            },
            updateLngLastLng: '',
            lng: {},
            messages: {
			    en: {
					title: 'Privacy Policy',
			        description: 'Privacy Policy of the HAQCS Remote app.',
			    },
			    de: {
					title: 'Privacy Policy',
			        description: 'Privacy Policy of the HAQCS Remote app.',
				},
				pl: {
					title: 'Privacy Policy',
			        description: 'Privacy Policy of the HAQCS Remote app.',
				}
			},
		}
	},
	props: [ 'language' ],
	metaInfo() {
		return {
			title: this.lng.title,
			titleTemplate: '%s | Haplabit',
			htmlAttrs: {
				lang: this.language,
			},
			meta: [
				{ name: 'description', content: this.lng.description },
				{ name: 'theme-color', content: '#00c853' }
			]
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::selection {
	background: #A7F7A6;
}

.spacing-32 {
	padding-top: 32px;
}

.spacing-128 {
	padding-top: 128px;
}

h1 {
	color: black;
	font-size: 2.2rem;
	font-weight: bold;
	font-family: Arial, Helvetica, sans-serif;
	margin-top: 8px;
	/* margin-bottom: -32px; */
	padding-left: 128px;
	padding-right: 128px;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// PrivacyPolicy.vue?2402c56e